import React, { useState } from "react";
import { Box, Flex, Text, Spinner } from "flicket-ui";
import { CaretDown, CaretUp } from "@phosphor-icons/react";
import pluralize from "pluralize";

interface TicketLineItem {
  name: string;
  price: number;
  type?: string;
}

interface ExchangeTicket {
  id: string;
  ticketNumber: string;
  lineItem: TicketLineItem;
  status?: string;
  seat?: {
    label?: string;
  };
  event?: {
    id: string;
    title?: string;
    venue?: {
      seating?: string;
    };
  };
}

interface TicketExchangeAccordionProps {
  tickets: ExchangeTicket[];
  ticketValue: number;
  isLoading?: boolean;
}

export const TicketExchangeAccordion: React.FC<TicketExchangeAccordionProps> = ({
  tickets,
  ticketValue,
  isLoading = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box
      width="100%"
      mb={2}
      borderBottom="1px solid"
      borderBottomColor="N100"
      pb={2}
    >
      <Box
        onClick={() => !isLoading && setIsOpen(!isOpen)}
        cursor={isLoading ? "default" : "pointer"}
        borderRadius="md"
      >
        <Flex justifyContent="space-between" alignItems="center">
          {isLoading ? (
            <Flex alignItems="center">
              <Spinner size={2} mr={2} />
              <Text variant="regular">Loading ticket information...</Text>
            </Flex>
          ) : (
            <Text variant="header.XS">
              Exchanging {tickets.length} {pluralize("ticket", tickets.length)}{" "}
            </Text>
          )}

          {!isLoading && (
            <Text variant="regular">
              {isOpen ? <CaretUp /> : <CaretDown />}
            </Text>
          )}
        </Flex>
      </Box>

      {isOpen && (
        <Box mt={3} maxHeight="200px" overflowY="auto">
          {tickets.map((ticket, index) => (
            <Flex
              key={ticket.id}
              justifyContent="space-between"
              mb={1}
              pb={1}
              borderBottom={index < tickets.length - 1 ? "1px solid" : "none"}
              borderBottomColor="N200"
            >
              <Text variant="small">{ticket.lineItem.name}</Text>
              <Text variant="small">${ticket.lineItem.price.toFixed(2)}</Text>
            </Flex>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default TicketExchangeAccordion;
